import { ruleDefinitionDefaults, defaultValidationTagRule, createValidator } from './TagRulesCommon'


const ruleDefinition =
{
    ...ruleDefinitionDefaults,
    ruleType: "TagProductsOnSale",
    title: "Auto Tag Products On Sale",
    description: "Automatically tag products with a specific tag that have their compare at price set and/or compare price is less than price. Optionally tag products that are not on sale.",
    example: "",
    additional: [],
    legacy: false,
    inProgress: false,
    previewType: "ProductTags",
    tags: ["Products", "Tags"],
    getDefaultRuleState: () => {
        return {
            name: null,
            trigger: "Automatic",
            settings: {
                ruleTypeId: "TagProductsOnSale",
                onSaleTag: "on-sale",
                notOnSaleTag: null,
                priceMustBeLowerThanCompareAtPrice: true,
            }
        }
    },
    createValidator: (onAsyncError) => {
        return createValidator(
            onAsyncError,
            [defaultValidationTagRule,
                (rule, errors) => {
                    if (rule.settings.onSaleTag == null || rule.settings.onSaleTag === "") {
                        errors["onSaleTag"] = "On sale tag must be specified";
                    }

                    if (rule.settings.priceMustBeLowerThanCompareAtPrice == null || rule.settings.priceMustBeLowerThanCompareAtPrice === "") {
                        errors["priceMustBeLowerThanCompareAtPrice"] = "Value is required";
                    }
                },
            ], null);
    }
};

export default ruleDefinition;